// custom.js
document.addEventListener("DOMContentLoaded", () => {
  // Select the cart drawer element
  if(window.location.hash.indexOf('#opencartdrawer') > -1) {
    document.querySelector('#cart-icon-bubble').click();
    const url = window.location.href.replace("#opencartdrawer", "");
    history.replaceState(null, null, url);
  }
});

$(document).ready(function() {

    $(".featured-collection-custom__slider").slick({
    dots: false,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          arrows:false
        }
      }
    ]
  });

  $(".featured-blog-custom__slider").slick({
    dots: false,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          arrows:false
        }
      }
    ]
  });

  $(".testimonials__list").slick({
    dots: false,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          arrows:false
        }
      }
    ]
  });

  $('body').on('keyup','.cart-coupon_offer-input #coupon_code_input', function(){
    if($(this).val() != ''){
      $(this).closest('.cart-coupon_offer-input').find('[data-inputapply]').removeAttr('disabled');  
    }else{
      $(this).closest('.cart-coupon_offer-input').find('[data-inputapply]').attr('disabled','disabled');
    }
    
  });

  function existingDiscounts(){
    const discountCodes = [];
    const discountPills = $('.cart-coupon_offer-input').find('.cart-discount__pill');
    for (const pill of discountPills) {
      if (typeof $(pill).attr('data-discount-code') === 'string') {
        discountCodes.push($(pill).attr('data-discount-code'));
      }
    }  
    return discountCodes;
  }

  $('body').on('click', '.discount-selector [data-applybutton]', function () {
    $('.offer_input_err').remove();
    var _this = $(this);
    var sectionId = _this.closest('cart-drawer').attr('section');
    var drawercart = document.querySelector('cart-drawer');
    var discountCodeValue = _this.attr('data-code');
    
    $(this).closest('.cart-drawer').find('#coupon_code_input').val(discountCodeValue).closest('.cart-coupon_offer-input').find('[data-inputapply]').removeAttr('disabled').trigger('click');
  });
  
  $('body').on('click', '.cart-coupon_offer-input [data-inputapply]', function () {
    $('.offer_input_err').remove();
    var _this = $(this);
    var sectionId = _this.closest('cart-drawer').attr('section');
    var drawercart = document.querySelector('cart-drawer');
    var discountCodeValue = _this.closest('.cart-coupon_offer-input').find('#coupon_code_input').val();
  
    if (discountCodeValue === '') {
      _this.closest('.cart-coupon_offer-input').after('<p class="offer_input_err">Please enter any code above.</p>');
      return;
    }
  
    var existingDiscountsValue = existingDiscounts();
    if (existingDiscountsValue.includes(discountCodeValue)) return;
  
    _this.addClass('loading');
    _this.find('.loading__spinner').removeClass('hidden');
  
    async function getupdatedata() {
      let response = await fetch(`${window.routes.cart_update_url}.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          discount: [...existingDiscountsValue, discountCodeValue].join(','),
          sections: drawercart.getSectionsToRender().map((section) => section.section)
        })
      });
      return await response.json();
    }
  
    function getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
  
    getupdatedata().then(data => {
      console.log(data);
      // const parsedState = JSON.parse(data);
      if (data.discount_codes.find(discount => discount.code === discountCodeValue && !discount.applicable)) {
        _this.closest('.cart-coupon_offer-input').after('<p class="offer_input_err">Discount code is not valid.</p>');
        _this.removeClass('loading');
        _this.find('.loading__spinner').addClass('hidden');
        return;
      }

      fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-drawer-items', '.drawer__footer'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  
      _this.removeClass('loading');
      _this.find('.loading__spinner').addClass('hidden');
    }).catch(error => {
      console.error('Error updating cart:', error);
      _this.removeClass('loading');
      _this.find('.loading__spinner').addClass('hidden');
    });
  });

  $('body').on('click','[data-removecode]', function(){
    $('.offer_input_err').remove();
    var _this = $(this);
    var sectionId = _this.closest('cart-drawer').attr('section');
    var drawercart = document.querySelector('cart-drawer');
    if(_this.closest('.cart-discount__pill').length > 0){
      var discountCodeValue = _this.closest('.cart-discount__pill').attr('data-discount-code');
    }else{
      var discountCodeValue = _this.closest('.input_wrapper').find('#coupon_code_input').val();
    }

    var existingDiscountsValue = existingDiscounts();
    
    const index = existingDiscountsValue.indexOf(discountCodeValue);
    if (index === -1) return;

    existingDiscountsValue.splice(index, 1);
    
    _this.addClass('loading');
    _this.find('.loading__spinner').removeClass('hidden');
  
    async function getupdatedata() {
      let response = await fetch(`${window.routes.cart_update_url}.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          discount: existingDiscountsValue.join(','),
          sections: drawercart.getSectionsToRender().map((section) => section.section)
        })
      });
      return await response.json();
    }
  
    function getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
  
    getupdatedata().then(data => {
      console.log(data);

      fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-drawer-items', '.drawer__footer'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  
      _this.removeClass('loading');
      _this.find('.loading__spinner').addClass('hidden');
    }).catch(error => {
      console.error('Error updating cart:', error);
      _this.removeClass('loading');
      _this.find('.loading__spinner').addClass('hidden');
    });
  });

  $('body').on('click','.discount-selector .available_offers_toggle',function(){
     $(this).toggleClass('active');
     $(this).next('.content_toggle').slideToggle();
  });

  // FAQ
  $('.faq-item-title').click(function(){
     $(this).toggleClass('active');
     $(this).next('.faq-item-content').slideToggle();
  });

  // ACCORDION TABS
  $('.accordion-tabs__title').click(function() {
    var $accordionList = $(this).closest('.accordion-tabs__list');
    var $accordionItem = $(this).closest('.accordion-tabs__item');
    var $accordionContent = $(this).next('.accordion-tabs__content');    
    // Check if the clicked item is already active
    var isActive = $accordionItem.hasClass('active');   
    // Remove active class from all items and slide up all contents
    $accordionList.find('.accordion-tabs__item').removeClass('active');
    $accordionList.find('.accordion-tabs__content').slideUp();    
    if (!isActive) {
        // Add active class and slide down the current item if it was not active
        $accordionItem.addClass('active');
        $accordionContent.slideToggle();
    }
  });

  // PRODUCT TAB
  $('.tabs-nav__item-list .tabs-nav__item').on("click", function(){
    var tab_nav = $(this).attr('data-nav');
    console.log('data-nav',tab_nav);
    $('.tabs-nav__item-list button').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.product-tab-content__container').find('.product-tab-nav-content').map(function(){
      var tab_item = $(this).attr('data-tab');
      console.log('data-tab',tab_item);
      if(tab_item == tab_nav) {
        $(this).addClass('active');
      }else {
        $(this).removeClass('active');
      }
    })
  })

  //CUSTOM MENU DRAWER
  $('.custom-drawer-submenu_btn').click(function(){
     $(this).toggleClass('active');
     $(this).next('.custom-menu-drawer__submenu').slideToggle();
  });
    
  
})